<template>
    <div v-if="!hasError">
        <div v-if="programChoice === 'CZ02P' || programChoice === 'CZ02S'" class="container image-container">
            <div class="col-lg-12">
                <div class="content-divider__info glossary-footer">
                    <p><sup style="letter-spacing: 0.1em;">*</sup>&nbsp;External laboratory tests and internal technical tests - 2020. Compared to the competitor most known lens-brands by consumers (2019 external brand tracking in 11 countries). The word 'overall' refers to anti-reflective coatings important criteria, ranked through an external quantitative consumer study - 2019.</p>
                    <!-- <p>Click the link above to place an order to try Crizal<sup>®</sup> Sapphire<sup>™</sup> HR lenses.</p> -->
                    <p>&nbsp;</p>
                </div>
            </div>
        </div>
        <div v-else-if="checkVariluxXrCoupon && !checkViewCoupon" class="container image-container">
            <div class="col-lg-12">
                <div class="content-divider__info glossary-footer">
                    <p><sup style="letter-spacing: 0.1em;">1</sup>&nbsp;Based on achieving the highest composite score among premium Progressive designs of leading U.S. competitors on 14 attributes identified as important by a survey of U.S. consumers. Measurements were the result of Essilor R&D state of the art avatar simulations 2022.</p>
                    <p><sup style="letter-spacing: 0.1em;">2</sup>&nbsp;Internal R&D simulations - 2022 - vs Varilux<sup>&reg;</sup> X series<sup>™</sup></p>
                    <p>&nbsp;</p>
                </div>
            </div>
        </div>
        <div v-else-if="checkVewCoupon" class="container image-container">
            <div class="col-lg-12">
                <div class="content-divider__info glossary-footer">
                    <p><sup style="letter-spacing: 0.1em;">1</sup>&nbsp;Internal R&D simulations – 2022 – according to patient behavior - The extension of the near vision zone is based on the patient need/results on the Near Vision Behavior test.</p>
                    <p><sup style="letter-spacing: 0.1em;">2</sup>&nbsp;©Essilor –Varilux® XR series -in-life consumer study –Eurosyn–2022 –France (n=73 progressive lens wearers; 65/73).<sup>™</sup></p>
                    <p>&nbsp;</p>
                </div>
            </div>
        </div>
        <div v-else-if="checkExtenseeCoupon" class="container image-container small-font">
            <div class="col-lg-2"></div>
            <div class="col-lg-8">
                <div class="content-divider__info glossary-footer">
                    <p>
                        <sup style="letter-spacing: 0.1em;">1</sup>&nbsp;Varilux<sup>&reg;</sup> Physio<sup>&reg;</sup> extensee<sup>™</sup> – in-real life consumer study - Eurosyn – 2024 – France (n=79 progressive lens wearers [75/79])
                    </p>
                    <p>
                        <sup style="letter-spacing: 0.1em;">2</sup>&nbsp;Varilux<sup>&reg;</sup> Physio<sup>&reg;</sup> extensee<sup>™</sup> – in-real life consumer study - Eurosyn – 2024 – France (n=79 progressive lens wearers [69/79])
                    </p>
                    <p>&nbsp;</p>
                </div>
            </div>
            <div class="col-lg-2"></div>
        </div>
        <div v-else-if="checkExtenseeClassicCoupon" class="container image-container small-font">
            <div class="col-lg-2"></div>
            <div class="col-lg-8">
                <div class="content-divider__info glossary-footer">
                    <p>
                        <sup style="letter-spacing: 0.05em;">1</sup>&nbsp;Varilux<sup>&reg;</sup> Physio<sup>&reg;</sup> extensee<sup>™</sup> – in-real life consumer study - Eurosyn – 2024 – France (n=79 progressive lens wearers [75/79])
                    </p>
                    <p>
                        <sup style="letter-spacing: 0.05em;">2</sup>&nbsp;Varilux<sup>&reg;</sup> Physio<sup>&reg;</sup> extensee<sup>™</sup> – in-real life consumer study - Eurosyn – 2024 – France (n=79 progressive lens wearers [69/79])
                    </p>
                    <p>&nbsp;</p>
                </div>
            </div>
            <div class="col-lg-2"></div>
        </div>
        <div v-else-if="checkExtenseeTrackCoupon" class="container image-container small-font">
            <div class="col-lg-2"></div>
            <div class="col-lg-8">
                <div class="content-divider__info glossary-footer">
                    <p>
                        <sup style="letter-spacing: 0.05em;">1</sup>&nbsp;Varilux<sup>&reg;</sup> Physio<sup>&reg;</sup> extensee<sup>™</sup> – in-real life consumer study - Eurosyn – 2024 – France (n=79 progressive lens wearers [75/79])
                    </p>
                    <p>
                        <sup style="letter-spacing: 0.05em;">2</sup>&nbsp;Varilux<sup>&reg;</sup> Physio<sup>&reg;</sup> extensee<sup>™</sup> – in-real life consumer study - Eurosyn – 2024 – France (n=79 progressive lens wearers [69/79])
                    </p>
                    <p>
                        <sup style="letter-spacing: 0.05em;">3</sup>&nbsp;Simulations are done during activities in near vision vs Varilux<sup>&reg;</sup> Physio<sup>&reg;</sup> extensee<sup>™</sup> - results according to patient behavior. Internal R&D simulations – 2024
                    </p>
                    <p>&nbsp;</p>
                </div>
            </div>
            <div class="col-lg-2"></div>

        </div>
        <div v-else-if="checkImmersiaCoupon" class="container image-container small-font">
            <div class="col-lg-2"></div>
            <div class="col-lg-8">
                <div class="content-divider__info glossary-footer">
                    <p><sup style="letter-spacing: 0.05em;">1</sup>&nbsp;New Varilux<sup>&reg;</sup> Immersia<sup>™</sup> provides up to 1.5m or 3m of comfortable vision compared to Single Vision Near Vision lenses.</p>
                    <p><sup style="letter-spacing: 0.05em;">2</sup>&nbsp;Internal R&D simulations - 2025 - head posture simulation on several prescriptions and several distances per device.</p>
                    <p><sup style="letter-spacing: 0.05em;">3</sup>&nbsp;EssilorLuxottica. (2025). Internal R&D simulations - Volume of vision simulation from 80cm (31.5 inches) to 3m (9.84 feet). Data on file.</p>
                    <p><sup style="letter-spacing: 0.05em;">4</sup>&nbsp;Internal R&D simulations – 2025 - volume of vision simulation up to 80cm</p>
                    <p>&nbsp;</p>
                </div>
            </div>
            <div class="col-lg-2"></div>
        </div>
        <div v-else-if="checkImmersiaVirCoupon" class="container image-container small-font">
            <div class="col-lg-2"></div>
            <div class="col-lg-8">
                <div class="content-divider__info glossary-footer">
                    <p><sup style="letter-spacing: 0.05em;">1</sup>&nbsp;New Varilux<sup>&reg;</sup> Immersia(tm) provides up to 1.5m or 3m of comfortable vision compared to Single Vision Near Vision lenses.</p>
                    <p><sup style="letter-spacing: 0.05em;">2</sup>&nbsp;Internal R&D simulations – 2025 - volume of vision simulation up to 80cm.</p>
                    <p><sup style="letter-spacing: 0.05em;">3</sup>&nbsp;EssilorLuxottica. (2025). Internal R&D simulations - Volume of vision simulation from 80cm (31.5 inches) to 3m (9.84 feet). Data on file.</p>
                    <p><sup style="letter-spacing: 0.05em;">4</sup>&nbsp;Internal R&D simulations - 2025 - head posture simulation on several prescriptions and several distances per device.</p>
                    <p><sup style="letter-spacing: 0.05em;">5</sup>&nbsp;Sánchez-Brau M, Domenech-Amigot B, Brocal-Fernández F, Seguí-Crespo M.<br>
                        Computer vision syndrome in presbyopic digital device workers and progressive lens design.<br>
                        Ophthalmic Physiol Opt. 2021 Jul;41(4):922-931. doi: 10.1111/opo.12832. Epub 2021 May 4.<br>
                        PMID: 33945635
                    </p>
                    <p>&nbsp;</p>
                </div>
            </div>
            <div class="col-lg-2"></div>
        </div>
    </div>
</template>

<script>
export default {
  props: ["programChoice", "couponCode", "hasError"],
  computed: {
    checkVariluxXrCoupon() {
        let coupontPretext = this.couponCode.split('-')[0]
        return coupontPretext.includes('VXXR')
    },
    checkVewCoupon() {
        let coupontPretext = this.couponCode.split('-')[0]
        return coupontPretext.includes('L244V')
    },
    checkExtenseeCoupon() {
        return this.couponCode.includes('VPE')
    },
    checkExtenseeClassicCoupon() {
        return this.couponCode.includes('VPC')
    },
    checkExtenseeTrackCoupon() {
        return this.couponCode.includes('VPT')
    },
    checkImmersiaCoupon() {
        return this.couponCode.includes('VIM');
    },
    checkImmersiaVirCoupon() {
        return this.couponCode.includes('VIR');
    }

    
  }
};
</script>

<style>
.container.image-container {
    max-width: 100rem;
    display: flex;
    margin: auto;
}
.smaller-font .content-divider__info p {
    font-size: 0.65rem; /* or smaller like 0.75rem if needed */
}

</style>